// API Data Hook
import { useQuizData } from "@/hooks/useQuizData";
// Zustand Store
import { useQuizStore } from "@/store/useQuizStore";
// Quiz Step Renderer
import StepRenderer from "@/components/StepRenderer";
import ProgressBar from "@/components/atoms/ProgressBar";
import Header from "@/components/atoms/Header";
import Loader from "../atoms/Loader";

const QuizPage = () => {
  const { data, isLoading } = useQuizData();
  const { step, saveAnswer, nextStep, answers } = useQuizStore();
  const loaderLabel =
    data?.settings?.staticLabels?.loaderLabel ||
    window.quizStaticLabels?.loaderLabel ||
    "Loading Quiz Questions";

  if (isLoading || !data)
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader duration={1.5} subtitle={loaderLabel} />
      </div>
    );

  const totalSteps = data.steps.length;
  const currentStep = data.steps[step];

  const isOfferStep = currentStep.type === "offer";

  const handleAnswer = (
    value: string | number | string[] | { value: string; unit: string },
  ) => {
    saveAnswer(currentStep.id, value);
    nextStep();
  };

  return (
    <div className="max-w-[620px] px-2.5 mx-auto py-9 gap-9 md:py-25 md:gap-14 flex-col flex">
      <Header logoSrc={data.settings?.logoUrl} />
      {!isOfferStep && (
        <ProgressBar currentStep={step} totalSteps={totalSteps - 2} />
      )}
      <StepRenderer
        key={currentStep.id}
        step={currentStep}
        onAnswer={handleAnswer}
        answers={answers}
        staticLabels={data.settings?.staticLabels}
      />
    </div>
  );
};

export default QuizPage;
